export const recoleccionesColumns = [
  {
    id: 'opciones',
    label: 'Opciones',
    type: 'opciones',
    actions: [
      {
        key: 'print',
        icon: 'Printer',
        tooltip: 'Imprimir recibo',
        className: 'text-purple-600 hover:bg-purple-50'
      },
      {
        key: 'preview',
        icon: 'Eye',
        tooltip: 'Ver detalle',
        className: 'text-blue-600 hover:bg-blue-50'
      },
      {
        key: 'bluetooth',
        icon: 'Bluetooth',
        tooltip: 'Imprimir por Bluetooth',
        className: 'text-cyan-600 hover:bg-cyan-50'
      },
      {
        key: 'verificar',
        icon: 'Check',
        tooltip: 'Verificar recolección',
        className: 'text-green-600 hover:bg-green-50',
        showWhen: (row) => row.estado === 'pendiente_verificacion'
      },
/*       {
        key: 'view',
        icon: 'Eye',
        tooltip: 'Ver detalles',
        className: 'text-blue-600 hover:bg-blue-50'
      }, */
      {
        key: 'delete',
        icon: 'Trash',
        tooltip: 'Eliminar',
        className: 'text-red-600 hover:bg-red-50'
      }
    ]
  },
  {
    id: 'consecutivo',
    label: 'Consecutivo',
    type: 'text',
    sortable: true,
    required: true
  },
  {
    id: 'estado',
    label: 'Estado',
    type: 'select',
    sortable: true,
    required: true,
    options: [
      { value: 'recibido', label: 'Recibido' },
      { value: 'pendiente_verificacion', label: 'Pendiente Verificación' },
      { value: 'verificado', label: 'Verificado' },
      { value: 'rechazado', label: 'Rechazado' },
      { value: 'entregado', label: 'Entregado' }
    ]
  },
  {
    id: 'empleado.nombre',
    label: 'Empleado',
    type: 'text',
    sortable: true,
    required: true
  },
  {
    id: 'empleado.cedula',
    label: 'Cédula',
    type: 'text',
    sortable: true,
    required: true
  },
  {
    id: 'empleado.celular',
    label: 'Celular',
    type: 'text',
    sortable: true,
    required: true
  },

  {
    id: 'cantidad_prendas',
    label: 'Total Prendas',
    type: 'number',
    sortable: true,
    required: true
  },
  {
    id: 'createdAt',
    label: 'Fecha Creación',
    type: 'datetime',
    sortable: true
  }
];

export const columnsExcel = [
  { id: 'consecutivo', label: 'Consecutivo' },
  { id: 'estado', label: 'Estado' },
  { id: 'empleado.nombre', label: 'Empleado' },
  { id: 'empleado.cedula', label: 'Cédula' },
  { id: 'empleado.celular', label: 'Celular' },
  { id: 'cantidad_prendas', label: 'Total Prendas' },
  { id: 'createdAt', label: 'Fecha Creación' }
];

// Función para procesar los datos antes de mostrarlos en la tabla
export const processRecoleccionData = (recolecciones) => {
  return recolecciones.map(recoleccion => ({
    ...recoleccion,
    id: recoleccion._id || recoleccion.id,
    consecutivo: recoleccion.consecutivo || 'N/A',
    'empleado.nombre': recoleccion.empleado?.nombre  + ' ' + recoleccion.empleado?.apellido || '',
    'empleado.cedula': recoleccion.empleado?.cedula || '',
    'empleado.celular': recoleccion.empleado?.celular || '',
    cantidad_prendas: recoleccion.cantidad_prendas || 0,
    createdAt: recoleccion.createdAt ? new Date(recoleccion.createdAt).toLocaleString() : ''
  }));
};
